export default __webpack_public_path__ + "static/media/45_4_0.4538879e.png";